export enum AuthConstants {
    AUTH_SIGNIN = 'AUTH/SIGNIN',
    AUTH_SIGNOUT = 'AUTH/SIGNOUT',
}
